<sc-padding [fitHeight]="true">
  <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
    <div>
      <sc-flex class="no-field-space">
    
        <mat-checkbox name="changeRouteManually" [(ngModel)]="registration.useAsShuttle" *ngIf="shuttleTransportsEnabled">
          {{'use as shuttle' | translate: ['tmc.transport.registration.routingPosition.use-as-shuttle',
          translationService.language]}}
        </mat-checkbox>
    
        <sc-content-spacer *ngIf="shuttleTransportsEnabled"></sc-content-spacer>
    
        <button class="reload-button" mat-stroked-button (click)="reloadRoute()">
          <sc-icon iconClass="fa-sync-alt"></sc-icon>
          <span>
            {{'reload route' | translate: ['tmc.transport.registration.routingPosition.action.reload-positions',
            translationService.language]}}
          </span>
        </button>
    
        <sc-content-spacer></sc-content-spacer>
    
        <mat-checkbox name="changeRouteManually" [(ngModel)]="registration.changeRouteManually"
          [disabled]="registration.changeRouteManually">
          {{'change route manually' | translate: ['tmc.transport.registration.routingPosition.change-route-manually',
          translationService.language]}}
        </mat-checkbox>
    
      </sc-flex>
    </div>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <sc-flex-fitting-content [vertical]="true">
      <sc-scroll-pane>

        <form class="form" #routeForm="ngForm">
          <div class="form-box route-list" cdkDropList (cdkDropListDropped)="drop($event)">
            <div class="draggable-form-box grid" cdkDrag
              [cdkDragDisabled]="!registration.changeRouteManually || position.readonly"
              *ngFor="let position of registration.routingPositions">
      
              <div class="row-flex" style="grid-column: 1; grid-row: 1;">
                <mat-form-field class="grow">
                  <input matInput [(ngModel)]="position.stationName" name="{{'station_'+position.index}}"
                    placeholder="{{'selectStation' | translate: ['tmc.transport.registration.routingPosition.selectStation', translationService.language]}}"
                    required [readonly]="true">
                </mat-form-field>
      
                <button mat-icon-button [disabled]="!registration.changeRouteManually || position.readonly"
                  (click)="assignStation(position)" class="small-button assign-button"><i
                    class="fa-light fa-sitemap"></i></button>
      
              </div>
      
              <mat-form-field style="grid-column: 2; grid-row: 1;" class="grow">
                <mat-label>
                  {{'actionType' | translate: ['tmc.transport.registration.routingPosition.actionType',
                  translationService.language]}}
                </mat-label>
                <mat-select [(ngModel)]="position.actionType" name="{{'actionType_'+position.index}}"
                  [disabled]="isActionTypeDisabled(position) || !registration.changeRouteManually || position.readonly">
                  <mat-option *ngFor="let o of actionTypeOptions" value="{{o.option}}">
                    {{o.name | translate: ['tmc.transport.registration.routingPosition.actionType.' + o.name,
                    translationService.language]}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
      
              <div class="row-flex" style="grid-column: 3; grid-row: 1;">
                <button mat-icon-button [disabled]="!registration.changeRouteManually || position.readonly"
                  [matTooltip]="'assigned tasks' | translate: ['tmc.transport.registration.routingPosition.assign-tasks', translationService.language]"
                  (click)="assignTasks(position)" class="small-button assign-task-button"
                  [ngClass]="{'no-tasks' : !position.tasks || position.tasks.length === 0}">
                  <i class="far fa-tasks"></i>
                </button>
              </div>
      
              <mat-form-field style="grid-row: 2;"
                [ngStyle]="cps.isEnabled('visitoverview.register.wait.for.retrieve.enabled', true)?{'grid-column':' 1'}:{'grid-column':' 1 / span 2'}">
                <input matInput [(ngModel)]="position.cargo" name="{{'cargo_'+position.index}}"
                  [readonly]="isCargoTypeDisabled(position)"
                  placeholder="{{'cargo' | translate: ['tmc.transport.registration.routingPosition.cargo', translationService.language]}}"
                  [required]="isCargoRequired(position)"
                  [minlength]="cps.getClientParamValue('visitoverview.register.minlength.cargo')" [maxlength]="255">
              </mat-form-field>
      
              <mat-checkbox style="grid-column: 2; grid-row: 2;" class="form-checkbox"
                [(ngModel)]="position.waitingForRetrieve" name="{{'waitinForRetrieve_'+position.index}}"
                [disabled]="isWaitingForRetrieveDisabled(position)  || !registration.changeRouteManually"
                *ngIf="cps.isEnabled('visitoverview.register.wait.for.retrieve.enabled', true)">
                {{'waitingForRetrieve' | translate: ['tmc.transport.registration.routingPosition.waitingForRetrieve',
                translationService.language]}}
              </mat-checkbox>
      
              <mat-form-field style="grid-column: 3; grid-row: 2;">
                <input matInput [(ngModel)]="position.predictedDuration" name="{{'predictedDuration_'+position.index}}"
                  [readonly]="isPredictedDurationDisabled(position) || !registration.changeRouteManually"
                  placeholder="{{'predicted duration' | translate: ['tmc.transport.registration.routingPosition.predicted-duration', translationService.language]}}"
                  appPositiveInteger type="number" min="0" required="false">
              </mat-form-field>
      
              <mat-form-field style="grid-column: 1; grid-row: 3;">
                <mat-label>
                  {{'station assignment strategy' | translate: ['tmc.common.entity.station-assignment-strategy',
                  translationService.language]}}
                </mat-label>
                <mat-select [(ngModel)]="position.stationAssignmentStrategy"
                  [required]="isStationAssignmentStrategyRequired(position)"
                  name="{{'stationAssignmentStrategy'+position.index}}"
                  [disabled]="isStationAssignmentStrategyDisabled(position)">
                  <mat-option *ngFor="let o of stationAssignmentStrategyOptions" value="{{o}}">
                    {{o | translate: ['tmc.common.entity.station-assignment-strategy.' + o,
                    translationService.language]}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
      
              <mat-form-field style="grid-column: 2 / span 3; grid-row: 3;">
                <input matInput [(ngModel)]="position.hint" name="{{'hint_'+position.index}}"
                  placeholder="{{'hint' | translate: ['tmc.transport.registration.routingPosition.hint', translationService.language]}}"
                  [required]="false" [maxLength]="1024" [readonly]="false">
              </mat-form-field>
      
              <div class="button-bar" style="grid-column: 4; grid-row: 1 / span 2;">
                <button mat-icon-button class="small-button remove-button" (click)="removePosition(position)"
                  [disabled]="!registration.changeRouteManually || position.readonly">
                  <sc-icon iconClass="fa-minus"></sc-icon></button>
              </div>
      
            </div>
          </div>
        </form>
        <div class="add-button-wrapper">
          <button class="add-button" mat-stroked-button (click)="addPosition()"
            [disabled]="!registration.changeRouteManually"><sc-icon iconClass="fa-plus"></sc-icon></button>
        </div>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
  </sc-flex>
</sc-padding>